import { ContractDocumentAPI } from "../api"
import moment from "moment"
export class ContractDocument {
    constructor(props) {
        for (const [key, value] of Object.entries(props)) {
            this[key] = value;
            this.updatedByText = this.updatedBy ? `${this.updatedBy.firstName} ${this.updatedBy.lastName}` : ''
            this.updatedAtText = this.updatedAt ? moment(this.updatedAt).format('DD MMM YYYY, HH:mm') : ''
        }
    }
    static async getContractDocument(payload) {
        const { data } = await ContractDocumentAPI.getContractDocument(payload);
        const classesData = new ContractDocument(data.result)
        return classesData
    }
    static async getContractDocuments(payload) {
        const { data } = await ContractDocumentAPI.getContractDocuments(payload);
        const classesData = data.result.map((item) => new ContractDocument(item));
        return classesData
    }
    static async updateContractDocument(payload) {
        const { data } = await ContractDocumentAPI.updateContractDocument(payload);
        const classesData = new ContractDocument(data.result)
        return classesData
    }
    static async removeContractDocument(payload) {
        const { data } = await ContractDocumentAPI.removeContractDocument(payload);
        const classesData = new ContractDocument(data.result)
        return classesData
    }
    static async createContractDocument(payload) {
        const { data } = await ContractDocumentAPI.createContractDocument(payload);
        const classesData = new ContractDocument(data.result)
        return classesData
    }
    static async createContractDocumentNoContract(payload) {
        const { data } = await ContractDocumentAPI.createContractDocumentNoContract(payload);
        const classesData = new ContractDocument(data.result)
        return classesData
    }
    static async getContractDocumentByContractIds(payload) {
        const { data } = await ContractDocumentAPI.getContractDocumentByContractIds(payload);
        const classesData = data.result.map((item) => new ContractDocument(item));
        return classesData
    }
}